import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { ICompanyNameIdLegalFormDTO } from '@modeso/types__aumico-lib-companies-be';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-valuation-report-dialog',
    templateUrl: './valuation-report-dialog.component.html',
    styleUrls: ['./valuation-report-dialog.component.scss'],
})
export class ValuationReportDialogComponent {
    companyControl = new FormControl();
    companyOptions: INameId[] = [
        { id: '1', name: 'Company A' },
        { id: '2', name: 'Company B' },
        // ... add other companies here
    ];
    filteredCompanies: INameId[] = [];

    constructor(
        public dialogRef: MatDialogRef<ValuationReportDialogComponent>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: ICompanyNameIdLegalFormDTO[],
    ) {
        this.addSvgIcon('interface-delete 1');
        this.addSvgIcon('aumico-pattern-delete-filled-blue');
        this.companyOptions = this.getCompanySelections(data);

        this.companyControl.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
            this.filterCompanies(value);
        });
    }

    private getCompanySelections(companies: ICompanyNameIdLegalFormDTO[]): INameId[] {
        return companies.map((company) => {
            return {
                id: company._id,
                name: company.name,
            };
        });
    }

    private filterCompanies(value: string | INameId): void {
        let filterValue: string;
        if (typeof value === 'string') {
            filterValue = value.toLowerCase();
        } else {
            filterValue = value.name.toLowerCase();
        }

        this.filteredCompanies = this.companyOptions.filter((company) =>
            company.name.toLowerCase().includes(filterValue),
        );
    }

    displayFn(company?: any): string | undefined {
        return company ? company.name : undefined;
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    onPlaceOrderClick(): void {
        this.dialogRef.close(this.companyControl.value);
    }
}
